const rmLeadsResults = {
  type: 'item',
  label: 'RM Leads Results',
  code: 'rmLeadsResults',
  dashboard_uid: 'rmLeadsResults',
  defaultFilters: {
    organization_unit: {
      department_type_uid: {
        value: '40eb1aaa-2b6f-4b30-aa84-2893d96b67af',
        label: 'Corporate RMs'
      }
    }
  },
  content: {
    items: [
      {
        type: 'analitics_widget',
        code: 'rmLeadsResults',
        def_version: 5,
        title: 'RM Leads Results',
        _rev: '2019-12-11',
        description_: 'Showing results of leads processes by RMs (per rm)',
        content: {
          data: {
            dataSources: [
              {
                code: 'AccountsListQM',
                name: 'AccountsListQM',
                type: 'QM',
                filter: {},
                fields: ['latest_owner_user_uid', 'sales_result_code'],
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  latest_owner_user_uid: 'user_uid',
                  latest_owner__department_uid: 'department_uid',
                  last_activity_date: 'activity_date'
                },
                transposeColumns: ['sales_result_code'],
                transposeKey: 'latest_owner_user_uid',
                transposeValueField: 'account_uid',
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                    accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                      edges { edge {  latest_owner_user_uid sales_result_code account_uid latest_owner { uid name type } } } } }`,
                qlVariables: {
                  groupBy: ['latest_owner_user_uid', 'sales_result_code'],
                  limit: 10
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'AccountsListQM',
                alias: 'AccountsDetailed',
                type: 'QM',
                filter: {},
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  latest_owner_user_uid: 'user_uid',
                  latest_owner: { department_uid: 'department_uid' },
                  last_activity_date: 'activity_date'
                },
                transposeColumns: ['detailed_status_code'],
                transposeKey: 'latest_owner_user_uid',
                transposeValueField: 'account_uid',
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                  edges { edge {  latest_owner_user_uid detailed_status_code account_uid } } } }`,
                qlVariables: {
                  groupBy: ['detailed_status_code', 'latest_owner_user_uid'],
                  limit: 10
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },

              {
                code: 'AccountsListQM',
                alias: 'OwnedLeads',
                type: 'QM',
                fields: ['owner_user_uid'],
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  last_activity_date: 'activity_date',
                  owner: {
                    department_uid: 'department_uid',
                    organization_unit_uid: 'organization_unit_uid'
                  }
                },
                filter: {
                  owner_type: 'user',
                  kind: { $ne: 'customer' }
                },
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                  edges { edge {  owner_user_uid account_uid } } } }`,
                qlVariables: {
                  groupBy: ['owner_user_uid'],
                  limit: 10
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'AccountsListQM',
                alias: 'AccountsWon',
                type: 'QM',
                fields: ['won_by_user_uid'],
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  won_by_user_uid: 'user',
                  won_by_user: {
                    department_uid: 'department_uid'
                  },
                  last_activity_date: 'activity_date'
                },
                filter: {
                  won_by_user_uid: { $ne: 'null' }
                },
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                  edges { edge {  won_by_user_uid account_uid } } } }`,
                qlVariables: {
                  groupBy: ['won_by_user_uid'],
                  limit: 100
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'OrdersListQM',
                name: 'OrdersListQM',
                type: 'QM',
                filter: {
                  status_code: 'completed'
                },
                aggregate: [{ id: 'order_uid', type: 'count' }],
                contextMapping: {
                  owner: {
                    department_uid: 'department_uid',
                    organization_unit_uid: 'organization_unit_uid'
                  },
                  completed_date: 'activity_date'
                },
                qlQuery: `query orders($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                  orders(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                  edges { edge {  owner_user_uid order_uid } } } }`,
                qlVariables: {
                  groupBy: ['owner_user_uid'],
                  limit: 10
                },
                qlEdges: true,
                qlRoot: 'orders'
              },
              {
                code: 'CrmUser',
                name: 'CrmUser',
                type: 'QM',
                filter: {},
                qlQuery: `query master($master_uid: String!, $instance_uid: String!, $filter: JSON) {
                      master(master_uid: $master_uid)  {
                          master_uid
                          name
                          instance(instance_uid: $instance_uid) {
                              instance_uid
                              name
                              users (filter: $filter) {
                                user_uid
                                is_active
                                full_name
                                contract_start_date
                                contract_end_date
                                department {
                                  name
                                }
                              }
                          }
                      }
                    }`,
                qlRoot: 'users'
              }
            ],
            combineDataSources: {
              name: 'CombinedDataSource',
              targetKeyField: 'user_uid',
              mapping: [
                {
                  fromDataSourceName: 'AccountsListQM',
                  keyField: 'latest_owner_user_uid',
                  mapping: [
                    {
                      from: 'account_uid',
                      to: 'accounts_all'
                    },
                    {
                      from: 'invalid',
                      to: 'accounts_invalid'
                    },
                    {
                      from: 'lost',
                      to: 'accounts_lost'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'AccountsDetailed',
                  keyField: 'latest_owner_user_uid',
                  mapping: [
                    {
                      from: 'new',
                      to: 'accounts_new',
                      type: 'number'
                    },
                    {
                      from: 'quoted',
                      to: 'accounts_quoted',
                      type: 'number'
                    },
                    {
                      from: 'contacted',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'touched',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'validated',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'needs_analysis',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'opportunity',
                      to: 'accounts_pending',
                      type: 'number'
                    }
                  ]
                },

                {
                  fromDataSourceName: 'OwnedLeads',
                  keyField: 'owner_user_uid',
                  mapping: [
                    {
                      from: 'account_uid',
                      to: 'owned_leads'
                    }
                  ]
                },

                {
                  fromDataSourceName: 'OrdersListQM',
                  keyField: 'owner_user_uid',
                  mapping: [
                    {
                      from: 'order_uid',
                      to: 'fitted_units'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'AccountsWon',
                  keyField: 'won_by_user_uid',
                  mapping: [
                    {
                      from: 'account_uid',
                      to: 'accounts_won'
                    }
                  ]
                },

                {
                  fromDataSourceName: 'CrmUser',
                  keyField: 'user_uid',
                  type: 'left',
                  mapping: [
                    {
                      from: 'full_name'
                    },
                    {
                      from: 'contract_start_date'
                    },
                    { from: 'contract_end_date' },
                    { from: 'department__name' },
                    { from: 'is_active' }
                  ]
                }
              ]
            }
          },
          layout: {
            items: [
              {
                type: 'table',
                def_version: 5,
                props: {
                  generate_summary: true,
                  generate_average: true,
                  initialSort: { id: 'contract_start_date', order: 'asc' },
                  columns: [
                    {
                      Header: '#',
                      accessor: 'index',
                      width: 30
                    },
                    {
                      Header: 'RM',
                      accessor: 'full_name',
                      align: 'left',
                      type: 'text',
                      classNameHandler: row => (row.original.is_active ? '' : 'util-opacity50'),
                      detailsPopup: 'user_dashboard',
                      detailsFilterMapping: {
                        user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Start Date',
                      accessor: 'contract_start_date',
                      width: 70,
                      type: 'text',
                      align: 'center'
                    },
                    {
                      Header: 'Leads',
                      accessor: 'accounts_all',
                      detailsPopup: 'account',
                      detailsFilter: { latest_owner_user_uid: { $ne: 'null' } },
                      detailsFilterMapping: {
                        latest_owner_user_uid: { user_uid: 'user_uid' }
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date'
                      },
                      className: ' util-pointer',
                      width: 60,
                      type: 'number'
                    },

                    {
                      Header: 'Won',
                      accessor: 'accounts_won',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {},
                      detailsFilterMapping: {
                        won_by_user_uid: { user_uid: 'user_uid' }
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date',
                        won_by_user: { department_uid: 'department_uid' }
                      }
                    },
                    {
                      Header: 'Lost',
                      accessor: 'accounts_lost',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        sales_result_code: 'lost',
                        latest_owner_user_uid: { $ne: 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid',
                        last_activity_date: 'activity_date'
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date'
                      }
                    },
                    {
                      Header: 'Untouched',
                      accessor: 'accounts_new',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'new',
                        latest_owner_user_uid: { $ne: 'null' }
                      },
                      detailsFilterMapping: {
                        last_activity_date: 'activity_date',
                        latest_owner_user_uid: 'user_uid'
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date'
                      }
                    },

                    {
                      Header: 'Quoted',
                      accessor: 'accounts_quoted',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'quoted',
                        latest_owner_user_uid: { $ne: 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date'
                      }
                    },
                    {
                      Header: 'Unquoted',
                      accessor: 'accounts_pending',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        latest_owner_user_uid: { $ne: 'null' },
                        detailed_status_code: {
                          $in: ['contacted', 'touched', 'validated', 'needs_analysis', 'opportunity']
                        }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      },
                      contextMapping: {
                        last_activity_date: 'activity_date'
                      }
                    },
                    {
                      Header: 'Fitted',
                      accessor: 'fitted_units',
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'order',
                      detailsFilter: {
                        owner_user_uid: { $ne: 'null' },
                        status_code: 'completed'
                      },
                      detailsFilterMapping: {
                        owner_user_uid: 'user_uid',
                        completed_date: 'activity_date'
                      }
                    },
                    {
                      Header: 'Wins to Leads',
                      accessorFn: row => {
                        const all = row ? Number(row.accounts_all) : undefined
                        const won = row ? Number(row.accounts_won) : undefined
                        if (all && won && !isNaN(all) && !isNaN(won) && all > 0 && won > 0) {
                          const res = Number((100 * won) / all)
                          return res && !isNaN(res) ? res : undefined
                        }
                      },
                      Cell: row => {
                        const all = row && row.original ? Number(row.original.accounts_all) : undefined
                        const won = row && row.original ? Number(row.original.accounts_won) : undefined
                        if (all && won && !isNaN(all) && !isNaN(won) && all > 0 && won > 0) {
                          const res = Number((100 * won) / all)
                          return res && !isNaN(res)
                            ? res.toLocaleString(undefined, {
                                maximumFractionDigits: 0
                              }) + '%'
                            : undefined
                        }
                      },
                      className: ' util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'customer'
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Fitments To Leads',
                      width: 60,
                      headerClassName: 'util-textCenter',
                      accessorFn: row => {
                        if (
                          !row ||
                          !row.fitted_units ||
                          !row.accounts_all ||
                          isNaN(row.fitted_units) ||
                          isNaN(row.accounts_all)
                        )
                          return undefined

                        const accounts = Number(row.accounts_all)

                        if (accounts <= 0) return 0

                        return Number(row.fitted_units) / accounts
                      },
                      type: 'number',
                      align: 'right',
                      maximumFractionDigits: 1
                    }
                  ],
                  data: {
                    type: 'dataSource',
                    dataSourceCode: 'CombinedDataSource'
                  }
                }
              }
            ]
          }
        }
      }
    ]
  }
}

export default rmLeadsResults
